// Generated by purs version 0.13.8
"use strict";
var Data_Argonaut_Decode_Class = require("../Data.Argonaut.Decode.Class/index.js");
var Data_Argonaut_Decode_Generic_Rep = require("../Data.Argonaut.Decode.Generic.Rep/index.js");
var Data_Argonaut_Encode_Class = require("../Data.Argonaut.Encode.Class/index.js");
var Data_Argonaut_Encode_Generic_Rep = require("../Data.Argonaut.Encode.Generic.Rep/index.js");
var Data_Default = require("../Data.Default/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Generic_Rep = require("../Data.Generic.Rep/index.js");
var Data_Lens_Lens = require("../Data.Lens.Lens/index.js");
var Data_Lens_Prism = require("../Data.Lens.Prism/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Ordering = require("../Data.Ordering/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Data_Unit = require("../Data.Unit/index.js");
var Lunarbox_Data_Editor_FunctionName = require("../Lunarbox.Data.Editor.FunctionName/index.js");
var Lunarbox_Data_Editor_Node_NodeId = require("../Lunarbox.Data.Editor.Node.NodeId/index.js");
var Lunarbox_Data_Editor_Node_PinLocation = require("../Lunarbox.Data.Editor.Node.PinLocation/index.js");
var Lunarbox_Data_String = require("../Lunarbox.Data.String/index.js");
var AtFunction = (function () {
    function AtFunction(value0) {
        this.value0 = value0;
    };
    AtFunction.create = function (value0) {
        return new AtFunction(value0);
    };
    return AtFunction;
})();
var InsideFunction = (function () {
    function InsideFunction(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    InsideFunction.create = function (value0) {
        return function (value1) {
            return new InsideFunction(value0, value1);
        };
    };
    return InsideFunction;
})();
var AtFunctionDeclaration = (function () {
    function AtFunctionDeclaration(value0) {
        this.value0 = value0;
    };
    AtFunctionDeclaration.create = function (value0) {
        return new AtFunctionDeclaration(value0);
    };
    return AtFunctionDeclaration;
})();
var FixpointOperator = (function () {
    function FixpointOperator(value0) {
        this.value0 = value0;
    };
    FixpointOperator.create = function (value0) {
        return new FixpointOperator(value0);
    };
    return FixpointOperator;
})();
var UnknownLocation = (function () {
    function UnknownLocation() {

    };
    UnknownLocation.value = new UnknownLocation();
    return UnknownLocation;
})();
var showLocation = new Data_Show.Show(function (v) {
    if (v instanceof AtFunction) {
        return "inside function" + Lunarbox_Data_String.doubleShow(Lunarbox_Data_Editor_FunctionName.showFunctionName)(v.value0);
    };
    if (v instanceof InsideFunction && v.value1 instanceof Lunarbox_Data_Editor_Node_PinLocation.FunctionDeclaration) {
        return "at the declaration of function " + Lunarbox_Data_String.doubleShow(Lunarbox_Data_Editor_FunctionName.showFunctionName)(v.value0);
    };
    if (v instanceof InsideFunction && v.value1 instanceof Lunarbox_Data_Editor_Node_PinLocation.NodeDefinition) {
        return "at node " + (Lunarbox_Data_String.doubleShow(Lunarbox_Data_Editor_Node_NodeId.showNodeId)(v.value1.value0) + (" in function " + Lunarbox_Data_String.doubleShow(Lunarbox_Data_Editor_FunctionName.showFunctionName)(v.value0)));
    };
    if (v instanceof InsideFunction) {
        return Data_Show.show(Lunarbox_Data_Editor_Node_PinLocation.showScopedLocation)(v.value1) + (" in function " + Lunarbox_Data_String.doubleShow(Lunarbox_Data_Editor_FunctionName.showFunctionName)(v.value0));
    };
    if (v instanceof UnknownLocation) {
        return "at an unknown location";
    };
    if (v instanceof AtFunctionDeclaration) {
        return "at the declaration of function " + Lunarbox_Data_String.doubleShow(Lunarbox_Data_Editor_FunctionName.showFunctionName)(v.value0);
    };
    if (v instanceof FixpointOperator) {
        return "at the recursion handler for " + Lunarbox_Data_String.doubleShow(Lunarbox_Data_Editor_FunctionName.showFunctionName)(v.value0);
    };
    throw new Error("Failed pattern match at Lunarbox.Data.Editor.Location (line 85, column 1 - line 92, column 84): " + [ v.constructor.name ]);
});
var genericLocation = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof AtFunction) {
        return new Data_Generic_Rep.Inl(x.value0);
    };
    if (x instanceof InsideFunction) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, x.value1)));
    };
    if (x instanceof AtFunctionDeclaration) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
    };
    if (x instanceof FixpointOperator) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))));
    };
    if (x instanceof UnknownLocation) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value))));
    };
    throw new Error("Failed pattern match at Lunarbox.Data.Editor.Location (line 74, column 1 - line 74, column 54): " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return new AtFunction(x.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
        return new InsideFunction(x.value0.value0.value0, x.value0.value0.value1);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
        return new AtFunctionDeclaration(x.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
        return new FixpointOperator(x.value0.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inr))) {
        return UnknownLocation.value;
    };
    throw new Error("Failed pattern match at Lunarbox.Data.Editor.Location (line 74, column 1 - line 74, column 54): " + [ x.constructor.name ]);
});
var eqLocation = new Data_Eq.Eq(function (x) {
    return function (y) {
        if (x instanceof AtFunction && y instanceof AtFunction) {
            return Data_Eq.eq(Lunarbox_Data_Editor_FunctionName.eqFunctionName)(x.value0)(y.value0);
        };
        if (x instanceof InsideFunction && y instanceof InsideFunction) {
            return Data_Eq.eq(Lunarbox_Data_Editor_FunctionName.eqFunctionName)(x.value0)(y.value0) && Data_Eq.eq(Lunarbox_Data_Editor_Node_PinLocation.eqScopedLocation)(x.value1)(y.value1);
        };
        if (x instanceof AtFunctionDeclaration && y instanceof AtFunctionDeclaration) {
            return Data_Eq.eq(Lunarbox_Data_Editor_FunctionName.eqFunctionName)(x.value0)(y.value0);
        };
        if (x instanceof FixpointOperator && y instanceof FixpointOperator) {
            return Data_Eq.eq(Lunarbox_Data_Editor_FunctionName.eqFunctionName)(x.value0)(y.value0);
        };
        if (x instanceof UnknownLocation && y instanceof UnknownLocation) {
            return true;
        };
        return false;
    };
});
var ordLocation = new Data_Ord.Ord(function () {
    return eqLocation;
}, function (x) {
    return function (y) {
        if (x instanceof AtFunction && y instanceof AtFunction) {
            return Data_Ord.compare(Lunarbox_Data_Editor_FunctionName.ordFunctionName)(x.value0)(y.value0);
        };
        if (x instanceof AtFunction) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof AtFunction) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof InsideFunction && y instanceof InsideFunction) {
            var v = Data_Ord.compare(Lunarbox_Data_Editor_FunctionName.ordFunctionName)(x.value0)(y.value0);
            if (v instanceof Data_Ordering.LT) {
                return Data_Ordering.LT.value;
            };
            if (v instanceof Data_Ordering.GT) {
                return Data_Ordering.GT.value;
            };
            return Data_Ord.compare(Lunarbox_Data_Editor_Node_PinLocation.ordScopedLocation)(x.value1)(y.value1);
        };
        if (x instanceof InsideFunction) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof InsideFunction) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof AtFunctionDeclaration && y instanceof AtFunctionDeclaration) {
            return Data_Ord.compare(Lunarbox_Data_Editor_FunctionName.ordFunctionName)(x.value0)(y.value0);
        };
        if (x instanceof AtFunctionDeclaration) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof AtFunctionDeclaration) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof FixpointOperator && y instanceof FixpointOperator) {
            return Data_Ord.compare(Lunarbox_Data_Editor_FunctionName.ordFunctionName)(x.value0)(y.value0);
        };
        if (x instanceof FixpointOperator) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof FixpointOperator) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof UnknownLocation && y instanceof UnknownLocation) {
            return Data_Ordering.EQ.value;
        };
        throw new Error("Failed pattern match at Lunarbox.Data.Editor.Location (line 72, column 1 - line 72, column 44): " + [ x.constructor.name, y.constructor.name ]);
    };
});
var encodeJsonLocation = new Data_Argonaut_Encode_Class.EncodeJson(Data_Argonaut_Encode_Generic_Rep.genericEncodeJson(genericLocation)(Data_Argonaut_Encode_Generic_Rep.encodeRepSum(Data_Argonaut_Encode_Generic_Rep.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
    return "AtFunction";
}))(Data_Argonaut_Encode_Generic_Rep.encodeRepArgsArgument(Lunarbox_Data_Editor_FunctionName.encodeJsonFunctionName)))(Data_Argonaut_Encode_Generic_Rep.encodeRepSum(Data_Argonaut_Encode_Generic_Rep.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
    return "InsideFunction";
}))(Data_Argonaut_Encode_Generic_Rep.encodeRepArgsProduct(Data_Argonaut_Encode_Generic_Rep.encodeRepArgsArgument(Lunarbox_Data_Editor_FunctionName.encodeJsonFunctionName))(Data_Argonaut_Encode_Generic_Rep.encodeRepArgsArgument(Lunarbox_Data_Editor_Node_PinLocation.encodeJsonScopedLocation))))(Data_Argonaut_Encode_Generic_Rep.encodeRepSum(Data_Argonaut_Encode_Generic_Rep.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
    return "AtFunctionDeclaration";
}))(Data_Argonaut_Encode_Generic_Rep.encodeRepArgsArgument(Lunarbox_Data_Editor_FunctionName.encodeJsonFunctionName)))(Data_Argonaut_Encode_Generic_Rep.encodeRepSum(Data_Argonaut_Encode_Generic_Rep.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
    return "FixpointOperator";
}))(Data_Argonaut_Encode_Generic_Rep.encodeRepArgsArgument(Lunarbox_Data_Editor_FunctionName.encodeJsonFunctionName)))(Data_Argonaut_Encode_Generic_Rep.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
    return "UnknownLocation";
}))(Data_Argonaut_Encode_Generic_Rep.encodeRepArgsNoArguments)))))));
var defaultLocation = new Data_Default.Default(UnknownLocation.value);
var decodeJsonLocation = new Data_Argonaut_Decode_Class.DecodeJson(Data_Argonaut_Decode_Generic_Rep.genericDecodeJson(genericLocation)(Data_Argonaut_Decode_Generic_Rep.decodeRepSum(Data_Argonaut_Decode_Generic_Rep.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
    return "AtFunction";
}))(Lunarbox_Data_Editor_FunctionName.decodeJsonFunctionName))(Data_Argonaut_Decode_Generic_Rep.decodeRepSum(Data_Argonaut_Decode_Generic_Rep.decodeRepConstructor(new Data_Symbol.IsSymbol(function () {
    return "InsideFunction";
}))(Data_Argonaut_Decode_Generic_Rep.decodeRepArgsProduct(Data_Argonaut_Decode_Generic_Rep.decodeRepArgsArgument(Lunarbox_Data_Editor_FunctionName.decodeJsonFunctionName))(Data_Argonaut_Decode_Generic_Rep.decodeRepArgsArgument(Lunarbox_Data_Editor_Node_PinLocation.decodeJsonScopedLocation))))(Data_Argonaut_Decode_Generic_Rep.decodeRepSum(Data_Argonaut_Decode_Generic_Rep.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
    return "AtFunctionDeclaration";
}))(Lunarbox_Data_Editor_FunctionName.decodeJsonFunctionName))(Data_Argonaut_Decode_Generic_Rep.decodeRepSum(Data_Argonaut_Decode_Generic_Rep.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
    return "FixpointOperator";
}))(Lunarbox_Data_Editor_FunctionName.decodeJsonFunctionName))(Data_Argonaut_Decode_Generic_Rep.decodeRepConstructorNoArgs(new Data_Symbol.IsSymbol(function () {
    return "UnknownLocation";
}))))))));
var _UnknownLocation = function (dictChoice) {
    return Data_Lens_Prism["prism'"](Data_Function["const"](UnknownLocation.value))(function (v) {
        if (v instanceof UnknownLocation) {
            return new Data_Maybe.Just(Data_Unit.unit);
        };
        return Data_Maybe.Nothing.value;
    })(dictChoice);
};
var _ScopedLocation = function (dictStrong) {
    return Data_Lens_Lens.lens(function (v) {
        if (v instanceof InsideFunction) {
            return new Data_Maybe.Just(v.value1);
        };
        return Data_Maybe.Nothing.value;
    })(function (other) {
        if (other instanceof InsideFunction) {
            return function (v) {
                if (v instanceof Data_Maybe.Just) {
                    return new InsideFunction(other.value0, v.value0);
                };
                if (v instanceof Data_Maybe.Nothing) {
                    return other;
                };
                throw new Error("Failed pattern match at Lunarbox.Data.Editor.Location (line 63, column 34 - line 65, column 27): " + [ v.constructor.name ]);
            };
        };
        return Data_Function["const"](other);
    })(dictStrong);
};
var _Function = function (dictStrong) {
    return Data_Lens_Lens.lens(function (v) {
        if (v instanceof AtFunction) {
            return new Data_Maybe.Just(v.value0);
        };
        if (v instanceof InsideFunction) {
            return new Data_Maybe.Just(v.value0);
        };
        if (v instanceof AtFunctionDeclaration) {
            return new Data_Maybe.Just(v.value0);
        };
        if (v instanceof FixpointOperator) {
            return new Data_Maybe.Just(v.value0);
        };
        return Data_Maybe.Nothing.value;
    })(function ($$function) {
        return function (maybeName) {
            if (maybeName instanceof Data_Maybe.Just) {
                if ($$function instanceof UnknownLocation) {
                    return UnknownLocation.value;
                };
                if ($$function instanceof InsideFunction) {
                    return new InsideFunction(maybeName.value0, $$function.value1);
                };
                if ($$function instanceof AtFunction) {
                    return new AtFunction(maybeName.value0);
                };
                if ($$function instanceof AtFunctionDeclaration) {
                    return new AtFunctionDeclaration(maybeName.value0);
                };
                if ($$function instanceof FixpointOperator) {
                    return new FixpointOperator(maybeName.value0);
                };
                throw new Error("Failed pattern match at Lunarbox.Data.Editor.Location (line 46, column 22 - line 51, column 54): " + [ $$function.constructor.name ]);
            };
            if (maybeName instanceof Data_Maybe.Nothing) {
                return $$function;
            };
            throw new Error("Failed pattern match at Lunarbox.Data.Editor.Location (line 45, column 30 - line 52, column 28): " + [ maybeName.constructor.name ]);
        };
    })(dictStrong);
};
module.exports = {
    AtFunction: AtFunction,
    InsideFunction: InsideFunction,
    AtFunctionDeclaration: AtFunctionDeclaration,
    FixpointOperator: FixpointOperator,
    UnknownLocation: UnknownLocation,
    "_UnknownLocation": _UnknownLocation,
    "_Function": _Function,
    "_ScopedLocation": _ScopedLocation,
    eqLocation: eqLocation,
    ordLocation: ordLocation,
    genericLocation: genericLocation,
    encodeJsonLocation: encodeJsonLocation,
    decodeJsonLocation: decodeJsonLocation,
    defaultLocation: defaultLocation,
    showLocation: showLocation
};
